import { DEFAULT_STALE_TIME } from '@/deprecated/services/constants'
import VariantService from '@/deprecated/services/VariantService'
import { useQuery } from '@tanstack/react-query'

export const useVariantsWorkspace = (variantId: string) => {
	const { data: workspace } = useQuery(
		['variants-workspace', variantId],
		() => VariantService.fetchVariantsWorkspace(variantId),
		{
			staleTime: DEFAULT_STALE_TIME,
			enabled: !!variantId,
		}
	)

	return {
		workspace,
	}
}
